/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Button, Modal, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useDisclosure } from '@chakra-ui/react';
import DynamicButton from '../Buttons/DynamicButton';
import useUserStore from '../../Hooks/Zustand/Store';
import { deleteDocumentFirebase, getCollectionFirebase } from '../../Api/firebaseApi';

function AccessRoleDeleteButton({ roleData, setRoleData, index }) {
  const globalState = useUserStore();
  const role = roleData?.[index];
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handlePopUp = async (e) => {
    e.stopPropagation();
    onOpen();
  };

  const handleDelete = async () => {
    if (!role?.id || !globalState?.currentCompany) return;
    setIsLoading(true);
    try {
      const res = await getCollectionFirebase('role_access_data', [
        { field: 'roleAccessId', operator: '==', value: role?.id },
        { field: 'companyId', operator: '==', value: globalState?.currentCompany },
        { field: 'projectId', operator: '==', value: globalState?.currentProject },
      ]);
      const deleteAccess = res?.map(async (x) => {
        if (x?.id) await deleteDocumentFirebase('role_access_data', x.id);
      });
      const deleteRole = await deleteDocumentFirebase('role_access', role?.id);

      await Promise.all([deleteAccess, deleteRole]);

      setRoleData((prev) => {
        const newData = [...prev];
        newData.splice(index, 1);

        return newData;
      });
      onClose();
    } catch (e) {
      setIsLoading(false);
      throw new Error(e.message);
    }
    setIsLoading(false);
  };

  return (
    <>
      <DynamicButton
        action="delete"
        size="sm"
        variant="solid"
        disabled={role?.title === 'users' ? true : false}
        onClick={(e) => handlePopUp(e)}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Hapus Role</ModalHeader>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button colorScheme="red" isLoading={isLoading} onClick={() => handleDelete()}>
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AccessRoleDeleteButton;
